import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-16">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg">
              <i className="ri-book-read-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950 whitespace-nowrap group-hover:text-primary-500 transition-colors">
              酷漫屋
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索漫画..."
              className="w-52 pl-9 pr-4 py-2 rounded-full text-sm border border-background-200 bg-background-100 focus:outline-none focus:border-primary-300 focus:bg-background-50 transition-all text-foreground-800 placeholder-foreground-400"
            />
          </div>
        </div>

        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
          aria-label="菜单"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-800`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === link.to
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="relative mt-2">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索漫画..."
              className="w-full pl-9 pr-4 py-3 rounded-lg text-sm border border-background-200 bg-background-100 focus:outline-none focus:border-primary-300 transition-all text-foreground-800 placeholder-foreground-400"
            />
          </div>
        </div>
      )}
    </header>
  );
}